import { Field } from '@/ui'
import React, { memo, useMemo } from 'react'
import styles from './DynamicField.module.scss'
import cl from 'classnames'
import { InfoGreen } from '@app/icons'
import { Alert } from '@/components/Alert/Alert'

export const DynamicField = memo((props) => {
	const {
		isRequired,
		placeholder,
		label,
		type,
		hint,
		options,
		className,
		error,
		...fieldProps
	} = props

	const renderType = {
		Number: (
			<Field
				type="number"
				hideNumberArrows
				isRequired={isRequired}
				label={label}
				placeholder={placeholder}
				hint={hint}
				wrapperClassName={styles.wrapperClassName}
				labelClassName={cl({
					[styles.labelClassName]: error
				})}
				error={error}
				{...fieldProps}
			/>
		),
		List: (
			<Field
				fieldType="radio"
				isRequired={isRequired}
				label={label}
				placeholder={placeholder}
				hint={hint}
				options={options}
				wrapperClassName={styles.wrapperClassName}
				labelClassName={cl({
					[styles.labelClassName]: error
				})}
				error={error}
				{...fieldProps}
			/>
		),
		Text: (
			<Field
				isRequired={isRequired}
				label={label}
				placeholder={placeholder}
				hint={hint}
				wrapperClassName={styles.wrapperClassName}
				labelClassName={cl({
					[styles.labelClassName]: error
				})}
				error={error}
				{...fieldProps}
			/>
		),
		TextManyRows: (
			<Field
				rows={8}
				fieldType="textarea"
				isRequired={isRequired}
				label={label}
				placeholder={placeholder}
				hint={hint}
				wrapperClassName={styles.wrapperClassName}
				labelClassName={cl({
					[styles.labelClassName]: error
				})}
				error={error}
				maxLength={4000}
				{...fieldProps}
			/>
		),
		Header: (
			<h3>
				<strong>{label}</strong>
			</h3>
		),
		Alert: (
			<Alert text={label} icon={<InfoGreen />} />
		),
	}

	return renderType[type] || false
})